import React, {useState, useRef, useEffect} from 'react'
import SubHeader from '../../components/Subheader/Subheader';
import { useSelector } from 'react-redux';
import CustomBreadcrumbs from '../../components/Tools/Breadcumbs';
import { Card, CardContent } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import './UpcomingPpa.css';
import { fetchUpcomingPPA, updateBankSettlements } from '../../helper/Api';
import Spinner from '../../components/Tools/spinner';
import { toast } from 'react-toastify';

const UpcomingPPAList = () => {
    const { financialYears } = useSelector((state) => state.authData);
    const fyIdRef = useRef(localStorage.getItem('globalDateId'));
    const fyList = financialYears.payload.fy_list;
    const [loading, setLoading] = useState(false);
    const [ppaList, setPpaList] = useState([]);
    const [ppaIds, setPpaIds] = useState([]);
    const handlePageTrigger = () => {
      fyIdRef.current = localStorage.getItem('globalDateId');
    }

    const fetchUpcomingPPAList = async () => {
        try {
            setLoading(true);
            const res = await fetchUpcomingPPA();
            if(res.data.status) {
                setLoading(false);
                setPpaList(res.data.result);
            }
        }catch(err) {
            setLoading(false);
            toast.error('Something went wrong', {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }

    const handleRowCheck = (ppaId) => {
        setPpaIds((prevIds) => {
            if (prevIds.includes(ppaId)) {
                return prevIds.filter((id) => id !== ppaId);
            } else {
                return [...prevIds, ppaId];
            }
        });
    }

    const handleOnHoldSubmit = async () => {
        try {
            setLoading(true);
            if(ppaIds.length === 0) {
                toast.error('Please select atleast one ppa.', {
                    position: toast.POSITION.TOP_CENTER
                });
                setLoading(false);
                return;
            }
            let body = {
                ppaArr: ppaIds
            }
            const res = await updateBankSettlements(body);
            if(res.data.status) {
                setLoading(false);
                await fetchUpcomingPPAList();
                toast.success('Bank Settlements updated successfully.', {
                    position: toast.POSITION.TOP_CENTER
                });    
            }
        }catch(err) {
            setLoading(false);
            toast.error('Bank Settlements not updated', {
                position: toast.POSITION.TOP_CENTER
            });
        }
        
    }

    useEffect(() => {
        fetchUpcomingPPAList();
    }, [])

    return (
        <div>
            {loading && <div > <Spinner/> </div>}
            <SubHeader fy_list={fyList} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>Upcoming Settlement PPA</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Upcoming Settlement PPA"/>
                </div>
                <div className="col-md-6">
                    <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                        <button type="button" className="submit_button" onClick={() => handleOnHoldSubmit()}>
                            <span className="fs-14px">Hold Selected ({ppaIds.length}) PPA</span>
                        </button>
                    </div>
                </div>
            </div>
            <div className='scheme p-2'>
                <Card>
                    <CardContent>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>#</TableCell>
                                        <TableCell>Settlement Id</TableCell>
                                        <TableCell>Settlement Date</TableCell>
                                        <TableCell>PPA ID</TableCell>
                                        <TableCell>No of Records</TableCell>
                                        <TableCell>Amount</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        ppaList.map((row, idx) => (
                                            <TableRow key={idx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                                <TableCell>
                                                    <input 
                                                        type="checkbox" 
                                                        checked={ppaIds.includes(row.id)}
                                                        onChange={() => handleRowCheck(row.id)}
                                                    /></TableCell>
                                                <TableCell>{row.settlement_id}</TableCell>
                                                <TableCell>{row.settlement_date}</TableCell>
                                                <TableCell>{row.ppa_no}-{row.id}</TableCell>
                                                <TableCell>{row.invoice_count}</TableCell>
                                                <TableCell>{row.amount}</TableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                </Card>
                
            </div>

        </div>
    )
}

export default UpcomingPPAList;